import { useRef } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';
import { closeDialog } from '../../store/modules/dialog';
import { setEditMode, setFileName, useDocInfoSliceSelector } from '../../store/modules/docInfo';
import { useExtensionHandleSliceSelector } from '../../store/modules/extensionHandle';
import { MESSAGE_TYPE } from '../../define/extension/message';
import { hideFileMenu } from '../../store/modules/popup';
import { setSaved } from '../../store/modules/docInfo';
import { saveFile, useIndexedDBDispatch, useIndexedDBState } from '../../context/indexedDBContext';
import { PO_EDIT_MODE } from '../../define/global';

export default function WhaleHandler() {
  const dispatch = useDispatch();
  const poSDKContextState = usePOWebofficeSDKState();
  const docInfoSlice = useDocInfoSliceSelector();
  const extMsgHandler = useExtensionHandleSliceSelector();
  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();
  const init = useRef(false);
  const source = useRef();
  const origin = useRef();

  const post = useCallback((message) => {
    if (source.current && origin.current) source.current.postMessage(message, origin.current);
  }, []);

  const postSaveFile = useCallback(
    (action) => {
      poSDKContextState.poInstance.handle.saveDocument().then((arg) => {
        const file = { name: docInfoSlice.fileName, blob: arg.blob };
        post({ action, file });
      });
    },
    [poSDKContextState.poInstance, docInfoSlice.fileName]
  );

  const messageHandler = useCallback(
    (event) => {
      try {
        console.log(event.data.action);
        switch (event.data.action) {
          case MESSAGE_TYPE.ACTION_TYPE.CHECK_INIT: {
            if (poSDKContextState.poInstance && init.current === false) {
              init.current = true;

              source.current = event.source;
              origin.current = event.origin;

              post({ action: MESSAGE_TYPE.ACTION_TYPE.INIT_COMPLETE });
            }
            break;
          }
          case MESSAGE_TYPE.ACTION_TYPE.OPEN_FILE: {
            dispatch(closeDialog());
            dispatch(setFileName(event.data.file.name));
            poSDKContextState.poInstance.handle
              .openDocument({ name: event.data.file.name, blob: event.data.file })
              .then(() => {
                if (poSDKContextState.poInstance.handle.getViewMode() === PO_EDIT_MODE.READ) {
                  //Open Read Only
                  dispatch(setEditMode(PO_EDIT_MODE.READ));
                }
                post({ action: MESSAGE_TYPE.ACTION_TYPE.OPEN_FILE_COMPLETE });
                poSDKContextState.poInstance.handle.saveDocument().then((arg) => {
                  saveFile({
                    state: indexedDBState,
                    dispatch: indexedDBDispatch,
                    file: new File([arg.blob], arg.name)
                  });
                });
              });
            break;
          }
          case MESSAGE_TYPE.ACTION_TYPE.SAVE_AS_FILE_COMPLETE: {
            dispatch(setFileName(event.data.filename));
            // DO NOT BREAK!!
          }
          case MESSAGE_TYPE.ACTION_TYPE.SAVE_FILE_COMPLETE: {
            dispatch(setSaved(true));
            // DO NOT BREAK!!
          }
          case MESSAGE_TYPE.ACTION_TYPE.EXPORT_PDF_COMPLETE: {
            dispatch(hideFileMenu());
            break;
          }
          case MESSAGE_TYPE.ACTION_TYPE.REQUEST_FILENAME: {
            const filename = docInfoSlice.fileName;
            post({ action: MESSAGE_TYPE.ACTION_TYPE.RESPONSE_FILENAME, filename });
            break;
          }
        }
      } catch (e) {
        console.log(`err : ${e}`);
      }
    },
    [poSDKContextState.poInstance]
  );

  useEffect(() => {
    window.addEventListener('message', messageHandler);
    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, [messageHandler]);

  useEffect(() => {
    if (extMsgHandler.message) {
      switch (extMsgHandler.message.action) {
        case MESSAGE_TYPE.ACTION_TYPE.SAVE_FILE:
        case MESSAGE_TYPE.ACTION_TYPE.SAVE_AS_FILE: {
          if (poSDKContextState.poInstance.handle.getViewMode() === PO_EDIT_MODE.READ) {
            postSaveFile(MESSAGE_TYPE.ACTION_TYPE.SAVE_AS_FILE);
          } else {
            postSaveFile(extMsgHandler.message.action);
          }
          break;
        }
        case MESSAGE_TYPE.ACTION_TYPE.EXPORT_PDF: {
          post({ action: MESSAGE_TYPE.ACTION_TYPE.EXPORT_PDF, file: extMsgHandler.message.file });
          break;
        }
        default: {
          post({
            action: extMsgHandler.message.action
          });
        }
      }
    }
  }, [extMsgHandler.message]);

  useEffect(() => {
    const filename = docInfoSlice.fileName;
    post({ action: MESSAGE_TYPE.ACTION_TYPE.RESPONSE_FILENAME, filename });
  }, [docInfoSlice.fileName]);

  return <></>;
}
